import type { Alert, AlertState } from "@/shared/api/models";

/**
 * 「미해제」 = 아직 상황이 끝나지 않은 경보 — `open`(신규) + `acknowledged`(조치 중).
 *
 * <p>⚠️ 2026-08-31 사고: 하단 탭 배지는 `state !== "cleared"` 로 **27** 을 띄우는데
 * 경보 화면 기본 필터는 `state === "open"` 이라 **0건**이었다. 실제 데이터가
 * acknowledged 27 · cleared 14 · open 0 이었기 때문이다. 숫자를 보고 탭을 눌렀는데
 * 아무것도 없는 화면이 나온다 — 안전 시스템에서 「경보가 27건 있다」와 「보여줄 게 없다」가
 * 동시에 참인 상태는 그 자체로 결함이다.</p>
 *
 * <p><b>acknowledged 는 「누가 봤다」이지 「해결됐다」가 아니다.</b> 해제(cleared)되기 전까지는
 * 현장에 위험이 남아 있는 상태이므로 미해제로 센다. 배지와 목록이 이 함수 하나를 공유해
 * 정의가 갈라질 수 없게 한다.</p>
 */
export function isUnresolved(a: Pick<Alert, "state">): boolean {
  return a.state !== "cleared";
}

/** 경보 화면의 상태 필터 값 — `active` 는 서버 상태가 아니라 화면 개념(미해제)이다. */
export type AlertStateFilter = AlertState | "active" | "all";

/** 필터 값에 맞는 경보만 남긴다. `active` 는 {@link isUnresolved} 와 같은 정의를 쓴다. */
export function matchesStateFilter(a: Pick<Alert, "state">, f: AlertStateFilter): boolean {
  if (f === "all") return true;
  if (f === "active") return isUnresolved(a);
  return a.state === f;
}
